import { useContext } from "react";
import CustomTable from "../../components/customTable/customTable.component";
import SideBar from "../../components/sideBar/sidebar.component";
import "./admin.styles.scss";
import { Options, SideBarContext } from "../../context/sidebar.context";
import { useFetchAdventures } from "../../api/queries/adventureQueries";
import { useFetchDestinations } from "../../api/queries/destinationQueries";
import moment from "moment";
import Button, {
  BUTTON_TYPE_CLASSES,
} from "../../components/button/button.component";
import { FormTypes } from "../../utils/formFactory";
import { FormContext } from "../../context/form.context";
import FormModal from "../../components/customForm/formModal.component";
import { useFetchProgrammes } from "../../api/queries/programmeQueries";

const AdminMainComponent = ({children, isFormOpen}) => {
  return (
    <>
      <div className="admin">
        <div className="admin__header">{/* <Navigation/> */}</div>
        <div className="admin__sidebar">
          <SideBar isFormOpen={isFormOpen} />
        </div>
        <main
          className={
            isFormOpen
              ? "admin__content u-position-fixed u-width-85"
              : "admin__content"
          }
        >
          {children}
        </main>
        <FormModal />
      </div>
    </>
  );
};

export default AdminMainComponent;
